import { createSelector } from 'reselect';
export const selectHubspotCreditsStatus = createSelector(state => state.appConfig.navExtensionTriggers, navExtensionTriggers => navExtensionTriggers.hubspotCreditsV2);